import React from "react";
import "./style.css";

const Kinds = () => {
  const Kinds_Data = [
    {
      img: (
        <svg
          version="1.1"
          id="transport"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="80px"
          height="70px"
          viewBox="0 0 80 70"
          enableBackground="new 0 0 80 70"
          xmlSpace="preserve"
          className="qodef--appear"
        >
          <g id="feather_5_">
            <path
              fill="none"
              stroke="#D7926B"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="M63.375,8.119 c0,0-32.725,11.688-46.75,53.762"
            ></path>
            <path
              fill="none"
              stroke="#D7926B"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="M24.806,44.35 C49.35,40.844,60.211,26.33,63.375,8.119"
            ></path>
            <path
              fill="none"
              stroke="#D7926B"
              strokeLinecap="round"
              strokeMiterlimit="10"
              d="M58.7,22.143c0,0-2.337-2.337-7.013-2.337"
            ></path>
            <path
              fill="none"
              stroke="#D7926B"
              strokeLinecap="round"
              strokeMiterlimit="10"
              d="M49.35,33.832c0,0-2.337-4.676-9.35-2.338"
            ></path>
          </g>
        </svg>
      ),
      name: "ECO LIVING",
      description: "At vero eos et accusamus et iusto odio dignissi",
    },
    {
      img: (
        <svg
          version="1.1"
          id="transport"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="80px"
          height="70px"
          viewBox="0 0 80 70"
          enable-background="new 0 0 80 70"
          xmlSpace="preserve"
          class="qodef--appear"
        >
          <g>
            <path
              fill="none"
              stroke="#D7926B"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              d="M55.872,57.435
		H16.568c-1.358,0-2.457-1.099-2.457-2.456V23.046c0-1.36,1.098-2.458,2.457-2.458h39.304c1.358,0,2.457,1.098,2.457,2.458v31.933
		C58.329,56.336,57.23,57.435,55.872,57.435z"
            ></path>
            <polygon
              fill="none"
              stroke="#D7926B"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              points="
		70.611,52.521 58.329,47.608 58.329,30.414 70.611,25.502 	"
            ></polygon>
            <line
              fill="none"
              stroke="#D7926B"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              x1="16.568"
              y1="9.533"
              x2="38.677"
              y2="9.533"
            ></line>
            <line
              fill="none"
              stroke="#D7926B"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              x1="53.415"
              y1="20.588"
              x2="38.677"
              y2="9.533"
            ></line>
          </g>
        </svg>
      ),
      name: "SURVEILLANCE",
      description: "At vero eos et accusamus et iusto odio dignissi",
    },
    {
      img: (
        <svg
          version="1.1"
          id="transport"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="80px"
          height="70px"
          viewBox="0 0 80 70"
          enable-background="new 0 0 80 70"
          xmlSpace="preserve"
          class="qodef--appear"
        >
          <g id="headset_3_">
            <g>
              <path
                fill="none"
                stroke="#D7926B"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                d="M19.091,46.252
			c0,0-7.319-2.18-7.319-4.878v-7.317c0-4.88,7.319-4.88,7.319-4.88V46.252z"
              ></path>
              <path
                fill="none"
                stroke="#D7926B"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                d="M60.559,46.252
			c0,0,7.318-2.18,7.318-4.878v-7.317c0-4.88-7.318-4.88-7.318-4.88V46.252z"
              ></path>
              <path
                fill="none"
                stroke="#D7926B"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                d="M62.998,46.252
			c0,9.758-8.495,14.551-17.076,14.636"
              ></path>
              <path
                fill="none"
                stroke="#D7926B"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-miterlimit="10"
                d="M43.483,63.326
			h-7.317c-1.35,0-2.44-1.088-2.44-2.438l0,0c0-1.345,1.091-2.437,2.44-2.437h7.317c1.348,0,2.438,1.092,2.438,2.437l0,0
			C45.922,62.238,44.831,63.326,43.483,63.326z"
              ></path>
            </g>
            <path
              fill="none"
              stroke="#D7926B"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              d="M60.559,29.177
		v-1.22c0-11.45-9.283-20.734-20.734-20.734l0,0c-11.451,0-20.733,9.284-20.733,20.734v1.22"
            ></path>
          </g>
        </svg>
      ),
      name: "RECEPTION",
      description: "At vero eos et accusamus et iusto odio dignissi",
    },
    {
      img: (
        <svg
          version="1.1"
          id="transport"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="80px"
          height="70px"
          viewBox="0 0 80 70"
          enable-background="new 0 0 80 70"
          xmlSpace="preserve"
          class="qodef--appear"
        >
          <g>
            <path
              fill="none"
              stroke="#D7926B"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              d="M54.936,24.268c0,4.018-3.141,7.273-7.014,7.273c-3.872,0-7.012-3.256-7.012-7.273v-4.154c0-4.018,3.14-7.273,7.012-7.273c3.873,0,7.014,3.256,7.014,7.273V24.268z"
            ></path>
            <circle
              fill="none"
              stroke="#D7926B"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              cx="29.222"
              cy="19.853"
              r="5.843"
            ></circle>
            <path
              fill="none"
              stroke="#D7926B"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              d="M35.107,38.882c-2.313-1.681-5.145-2.667-8.223-2.667c-6.825,0-12.506,4.886-13.768,11.337c-0.28,1.405,0.889,2.688,2.314,2.688h11.454"
            ></path>
            <path
              fill="none"
              stroke="#D7926B"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              d="M47.922,38.553L47.922,38.553c-9.425,0-17.223,6.974-18.512,16.043c-0.2,1.401,0.917,2.657,2.334,2.657h32.357c1.415,0,2.533-1.256,2.334-2.657C65.146,45.526,57.348,38.553,47.922,38.553z"
            ></path>
          </g>
        </svg>
      ),
      name: "MANAGEMENT",
      description: "At vero eos et accusamus et iusto odio dignissi",
    },
  ];

  return (
    <section className="Kinds_Container">
      {Kinds_Data.map((e) => (
        <div className="Kind">
          <div className="Kind_Img">
            {e.img}
          </div>
          <div className="Kind_Info">
            <div>
              <h3>{e.name}</h3>
            </div>
            <div>
              <p>{e.description}</p>
            </div>
          </div>
        </div>
      ))}
    </section>
  );
};

export default Kinds;
